import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/store/auth';

export interface GlobalMenuEntry {
  name: string;
  path: string;
  title: string;
  icon: string;
  menuOrder: number;
}

export function useGlobalMenu() {
  const router = useRouter();
  const authStore = useAuthStore();

  const entries = computed<GlobalMenuEntry[]>(() => {
    return router
      .getRoutes()
      .filter((route) => {
        if (!route.meta.showInMenu) return false;
        return authStore.hasMenuPermission(String(route.name || route.path));
      })
      .map((route) => ({
        name: String(route.name || route.path),
        path: route.path,
        title: (route.meta.title as string) || String(route.name || route.path),
        icon: (route.meta.menuIcon as string) || '📌',
        menuOrder: Number(route.meta.menuOrder || 999),
      }))
      .sort((a, b) => a.menuOrder - b.menuOrder);
  });

  return {
    entries,
  };
}
